// extracted by mini-css-extract-plugin
export default {"handWrapper":"Hand_handWrapper__Bmdse","hand":"Hand_hand__pOu3f","handImg":"Hand_handImg__it7N0","fingers":"Hand_fingers__FeOIJ"};